<template>
  <section class="pa-3 hero pa-md-10">
    <v-row>
        <v-col cols="6" lg="6" md="6" class="mx-auto">
          <div class="login-form">
            <div class="separator"><h3 class="text-center mb-8">{{ $t("become.partner") }}</h3></div>
            <v-form ref="form" lazy-validation>
              <v-row>
                <v-col cols="10" lg="10" md="10" class="mx-auto">
                  <p style="text-align:center;color:red">{{ errorMsg }}</p>
                  <v-text-field v-model="form.name" label="your restaurant name" outlined filled></v-text-field>
                  <google-maps-address
                        class="google-maps-field info-client-tex"
                        v-model="form.address"
                        v-on:updateaddress="updateAddress">
                    </google-maps-address>
                  <v-text-field v-model="form.email" :rules="emailRules" :label="$t('auth.email')" outlined filled></v-text-field>
                  <v-text-field v-model="form.phone" label="phone" outlined filled></v-text-field>
                  <div>
                    <v-btn large block class="primary my-8" @click="handleLogin">{{ $t("become.create") }}</v-btn>
                  </div>
                </v-col>
              </v-row>
            </v-form>
          </div>
        </v-col>
    </v-row>
  </section>
</template>
<script>
import { mapActions , mapMutations} from "vuex";
import GoogleMapsAddress from '@/components/GoogleMapsAddress'

export default {
  name: 'Home',
    /*
    |--------------------------------------------------------------------------
    | Component > components
    |--------------------------------------------------------------------------
    */
    components:{
        GoogleMapsAddress
    },
  data() {
    return {
      errorMsg: '',
      form: {
        email: '',
        phone: '',
        name: '',
        address: ''
      },
      emailRules: [
        v => !!v || 'E-mail is required',
        v => /.+@.+\..+/.test(v) || 'E-mail must be valid email.',
      ],
      prevRoute: null
    };
  },

  methods: {
    ...mapActions({
      becomePartner: "auth/becomePartner"
    }),

    async handleLogin () {
      let validate = this.$refs.form.validate()
      if(validate) {
        let data = await this.becomePartner(this.form)
        console.log(data)

        if(data.status == 200 || data.status == 201) {
          window.location.reload();
        } else {
         // this.errorMsg = data.message
        }
      }
    },
    /**
     * @param {object} location
     * @returns {void}
     */
    updateAddress (location) {
        /*const _this = this
        this.details.postal_code = location.postal_code;
        this.details.coordinates = location.coorinates;
        if(location.postal_code.startsWith('J8') || location.postal_code.startsWith('J9')) {
            this.iAddress = this.details.address
            this.iPostal = location.postal_code
            this.iCoorinates = location.coorinates
        }else {
            this.details.address = this.cartAddress
            this.details.postal_code = this.cartPostal;
            Notification({
                title: _this.$t('important'),
                message: _this.$t('txt_warning'),
                type: 'error'
            });
        }*/
    },
  },
  created() {
    
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.prevRoute = from
    })
  },
}
</script>
<style scoped>
.hero {
  background-size: cover;
}

.login-form {
  border: 2px solid rgb(35, 35, 104);
  padding: 5px;
  border-radius: 20px;
}

.v-text-field--outlined >>> fieldset {
  border-color: black;
}

.btn-facebook-signin{
  border-radius: 5px;
  width: 100%;
  display: block;
  font-weight: 600;
  font-size: 16px;
  margin: 5px 2px;
  box-sizing: border-box;
  border-width: 2px;
  background-color: #3c66c4;
  border-color: #ce3333;
  color: #fff;
  padding: 10px;
}
.btn-google-signin {
  border-radius: 5px;
  width: 100%;
  display: block;
  font-weight: 800;
  font-size: 16px;
  box-sizing: border-box;
  border-width: 2px;
  margin: 5px 2px;
  background-color: #ce3333;
  border-color: #ce3333;
  color: #fff;
  padding: 10px;
}

.separator {
  display: flex;
  align-items: center;
  text-align: center;
}

.separator::before,
.separator::after {
  content: '';
  flex: 1;
  border-bottom: 1px solid #000;
}

.separator:not(:empty)::before {
  margin-right: .25em;
}

.separator:not(:empty)::after {
  margin-left: .25em;
}
</style>
